<!-- Toolbar -->
	<!-- Container -->
	<div class="kt-container-fluid flex items-center justify-between flex-wrap gap-5">
		<div class="flex items-center flex-wrap gap-1 lg:gap-5">
			<h1 class="font-medium text-lg text-mono">
				Dashboard
			</h1>
			<div class="flex items-center gap-1 text-sm font-normal">
			</div>
		</div>
		<div class="flex items-center gap-1">
			<a class="kt-btn kt-btn-outline" href="#">
				View Profile
			</a>
		</div>
	</div>
	<!-- End of Container -->
<!-- End of Toolbar -->